<template>
  <v-row class="mt-1" >
    <span class="text-caption ml-5 mb-1 pl-1 pr-1 grey lighten-2"> Прикреплённые файлы ({{claim.FILE_LIST ? claim.FILE_LIST.length : '0'}})</span>
    <v-col cols="11" class="scrolled">
      <v-chip-group column>
          <v-chip
            v-for="file_item in claim.FILE_LIST"
            :key="file_item.DD_ID"
            :close="claim.DS_ID == 0"
            class=" ma-1"
            @click:close="deleteFile(file_item)"
            @click="loadFile(file_item)"
          >
            <v-icon left :color="getFileIcon(file_item).iconColor" v-text="getFileIcon(file_item).icon">
            </v-icon>
            {{file_item.DD_FILE_NAME}}
          </v-chip>
      </v-chip-group>
    </v-col>
    <v-col cols="1" class="pl-0 pr-0 pt-0 align-start">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab dark x-small color="green" class="ml-2 mr-2"
            @click="showAddFile"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon dark>mdi-paperclip</v-icon>
          </v-btn>
        </template>
        <span> Добавить файл </span>
      </v-tooltip>
    </v-col>
    <claim-add-file-dialog :claim="claim" v-model="showAddFileDialog" />
  </v-row>
</template>

<script>
import axios from 'axios'
import { CLM_DEL_FILE } from '@/store/actions/claims'
import { UI_SNACKBAR } from '@/store/actions/ui'
import ClaimAddFileDialog from '@/components/modules/claims/dialogs/claimAddFileDialog'
import { authMixin } from '@/components/modules/mixins/authUtils'
export default {
  name: 'claimFilesList',
  components: { ClaimAddFileDialog },
  props: ['claim'],
  mixins: [authMixin],
  data: () => ({
    orderFile: null,
    showAddFileDialog: false
  }),
  computed: {
    requestID: {
      get: function () {
        return this.claim.DOC_ID
      }
    },
    editable: {
      get: function () {
        const orderState = this.claim.DS_ID
        const ret =
          (this.userHaveRole('5cc39270-f880-4575-a355-2572c1cafdc6') && orderState === '0') || // Сотрудник
          (this.userHaveRole('0147896a-9761-45c9-b3e7-39437beb2f4b') && orderState === '0') || // ΤΑ
          (this.userHaveRole('b206f254-1c4c-4307-a054-9893442b8553') && orderState === '1') // РегАдмин/Техподдержка
        return ret
      }
    }
  },
  methods: {
    showAddFile () {
      this.showAddFileDialog = true
    },
    deleteFile (file) {
      console.log('Requested file delete', file)
      this.$store.dispatch(CLM_DEL_FILE, file)
        .then(() => {
          this.$store.commit(UI_SNACKBAR, { color: 'green lighten-1', text: 'Файл удален' })
        })
        .catch(err => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка удаления файла: ' + err })
        })
    },
    loadFile (file) {
      console.log('Requested file load', file)
      axios({ url: '/api/claims/downloadClaimDocument.php', data: file, method: 'POST', responseType: 'blob' })
        .then(resp => {
          const blob = new Blob([resp.data], { type: resp.headers['content-type'] })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = file.DD_FILE_NAME
          link.click()
          this.$store.commit(UI_SNACKBAR, { color: 'green lighten-1', text: 'Файл получен' })
        }).catch(err => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка загрузки файла: ' + err })
        })
    },
    getFileIcon (file) {
      const iconInfo = {
        icon: 'mdi-file',
        iconColor: 'black'
      }
      switch (file.DD_FILE_MIME) {
        case 'application/vnd.ms-excel':
          iconInfo.icon = 'mdi-file-excel-box'
          iconInfo.iconColor = 'green'
          break
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          iconInfo.icon = 'mdi-file-excel-box'
          iconInfo.iconColor = 'green'
          break
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          iconInfo.icon = 'mdi-file-word-box'
          iconInfo.iconColor = 'blue'
          break
        case 'application/pdf':
          iconInfo.icon = 'mdi-file-pdf-box'
          iconInfo.iconColor = 'red'
          break
        case 'image/jpeg':
          iconInfo.icon = 'mdi-image'
          iconInfo.iconColor = 'amber accent-3'
          break
      }
      return iconInfo
    }
  },
  created: function () {
  }
}
</script>

<style scoped>
.scrolled {
  height: 10vh;
  overflow-y: auto;
  overflow-x: hidden;
}
::-webkit-scrollbar {
  width: 0.5em;
  height: 0.5em;
}
/* Up */
::-webkit-scrollbar-button:single-button:vertical:decrement {
  height: 10px;
  width: 10px;
  background-position: center 4px;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' fill='rgb(96, 96, 96)'><polygon points='5,0 0,5 10,5'/></svg>");
}

/* Down */
::-webkit-scrollbar-button:single-button:vertical:increment {
  height: 10px;
  width: 10px;
  background-position: center 2px;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' fill='rgb(96, 96, 96)'><polygon points='0,0 10,0 5,5'/></svg>");
}

::-webkit-scrollbar-track-piece {
  background: #fff
}
::-webkit-scrollbar-thumb {
  background: #bbb;
  border-radius: 3px;
}

</style>
